import { motion } from "framer-motion";
import { SkeletonElement } from "./SkeletonElement";

export const ShimmerCard = ({
  showTags = true,
  showMetadata = true,
  showBody = true,
}: {
  showTags?: boolean;
  showMetadata?: boolean;
  showBody?: boolean;
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className="flex w-full flex-col rounded-md border-[1px] border-gray-200 bg-white transition-all duration-200"
    >
      <div className="w-full flex-1 px-3 py-3 text-gray-900">
        <div className="flex items-start">
          <div className="min-w-0 flex-1">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-x-2">
                <div className="h-8 w-8 flex-shrink-0 rounded-md bg-gray-100 p-1">
                  <SkeletonElement className="h-6 w-6" />
                </div>
                <div className="pr-2">
                  <SkeletonElement className="h-4 w-32" />
                </div>
              </div>
              <SkeletonElement className="h-9 w-9" />
            </div>

            <div
              className={`ml-[40px] mt-2 flex flex-col items-start justify-between ${
                showMetadata || showBody || showTags ? "flex" : "hidden"
              }`}
            >
              {showMetadata && (
                <div className="flex w-full flex-wrap gap-1 text-sm text-gray-400">
                  <div className="flex items-center gap-x-1.5">
                    <div className="flex items-center gap-1">
                      <SkeletonElement className="h-3.5 w-3.5" />
                      <SkeletonElement className="h-3 w-16" />
                    </div>
                    <span className="mr-1.5 flex-shrink-0">•</span>
                  </div>
                  <div className="flex items-center gap-x-1.5">
                    <div className="flex items-center gap-1">
                      <SkeletonElement className="h-3.5 w-3.5" />
                      <SkeletonElement className="h-3 w-20" />
                    </div>
                    <span className="mr-1.5 flex-shrink-0">•</span>
                  </div>
                  <div className="flex items-center gap-x-1.5">
                    <div className="flex items-center gap-1">
                      <SkeletonElement className="h-3.5 w-3.5" />
                      <SkeletonElement className="h-3 w-12" />
                    </div>
                  </div>
                </div>
              )}

              {showBody && (
                <div className="mt-2 text-sm">
                  <SkeletonElement className="mb-1 h-3 w-full" />
                  <SkeletonElement className="h-3 w-4/5" />
                </div>
              )}

              {showTags && (
                <div className="mt-2 flex flex-wrap items-center gap-1">
                  <SkeletonElement className="h-5 w-16 rounded-full" />
                  <SkeletonElement className="h-5 w-20 rounded-full" />
                  <SkeletonElement className="h-5 w-14 rounded-full" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
